import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { HbaseLinkedService } from 'app/model/linkedservice/hbase.linkedservice';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';
import { format } from 'app/shared/utils/string.util';

export const hBaseObjectMetadata: IDatasetTypeMetadata = {
    type: 'HBaseObject',
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.HBase_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(HbaseLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-hbase'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['Database']
};
